import { z } from "zod"
import { DurationSchema, TimelineSchema, PositionSchema } from "./timing"

export const EmojiContentSchema = z.object({
  id: z.string(),
  emoji: z.string(),
  scale: z.number().default(1.0),
})

export const EmojiSegmentSchema = z.object({
  id: z.string(),
  contentType: z.literal("Emoji"),
  duration: DurationSchema,
  timeline: TimelineSchema,
  content: EmojiContentSchema,
  position: PositionSchema,
})

export type EmojiContent = z.infer<typeof EmojiContentSchema>
export type EmojiSegment = z.infer<typeof EmojiSegmentSchema>
